// extracted by mini-css-extract-plugin
export default {"zoomModal":"t0-z"};